import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { TabloStaticPhotoConfig } from '@ui/tablo-generator/types';
import { TypedFormBuilder } from '@ui/form/TypedFormBuilder';
import { filter, takeUntil, tap } from 'rxjs/operators';
import { AliveState } from 'ZalamoLibrary/src/lib/core/ActiveState';
import { Required } from 'ZalamoLibrary/src/lib/core/decorators/Required';
import { ImagesInContextDrawerComponent } from '@ui/image-management/images-in-context-drawer/images-in-context-drawer.component';
import { ZalamoDialogService } from '@ui/zalamo-dialog/zalamo-dialog.service';
import { PublicSessionOrganizationSettings } from '../../../../../../../photographer-panel/src/graphql';
import { UploadContext } from 'Upload/upload/graphql';

@Component({
    selector: 'lib-static-photo-config-editor',
    templateUrl: './static-photo-config-editor.component.html',
    styleUrls: ['./static-photo-config-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StaticPhotoConfigEditorComponent
  extends AliveState
  implements OnInit
{
  model = this.fb.typedGroup<TabloStaticPhotoConfig>({
    childPhotoFrameColor: [''],
    childPhotoFrameWidth: [0],
    childPhotoShadow: [''],
    childPhotoOverlayFileName: [''],
    photoAsCircle: [false],
    photoAsSquare: [false],
    childRadius: [0],
    childTilt: [0],
    sideMargin: [0],
    childPhotoOverlayScale: [1],
    photoId: [''],
    photoGroupId: [''],
    scale: [1],
    y: [50],
    x: [50],
    schoolPhotoNumber: [0],
    height: [0],
    width: [0],
    fileName: [''],
  });
  schoolPhotoContext = UploadContext.PublicSessionOrganizationLogo;

  selfUpdate = false;
  @Input() @Required photoType!: 'child' | 'school';
  @Output() updated = new EventEmitter<TabloStaticPhotoConfig>();
  @Input() @Required uploadContextForAssets: any;
  @Input() @Required projectId: string;

  @Input() set currentConfig(config: TabloStaticPhotoConfig) {
    this.selfUpdate = true;
    this.model.patchValue(config);
    this.selfUpdate = false;
  }

  @Input() @Required context: any;
  @Input() @Required contextId: string;
  @Input() organizationSettings: PublicSessionOrganizationSettings;
  @Input() @Required publicSessionOrganizationId!: string;

  constructor(
    private fb: TypedFormBuilder,
    private zalamoDialogService: ZalamoDialogService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.subscribeWhileAlive(
      this.model.valueChanges.pipe(
        filter(() => !this.selfUpdate),
        tap((value) => this.updated.emit(value)),
      ),
    );
  }

  pickPhoto() {
    const ref = this.zalamoDialogService.openFull(
      ImagesInContextDrawerComponent,
      {
        closable: true,
      },
    );
    const { componentInstance } = ref;
    componentInstance.context = this.context as any;
    componentInstance.contextId = this.contextId;
    componentInstance.isPicker = true;
    componentInstance.pickerSingleMode = true;
    componentInstance.selected
      .pipe(takeUntil(ref.afterClosed()))
      .subscribe(([{ photo, photoGroupId }]) => {
        console.log(photo);
        this.model.patchValue({
          photoId: photo.photoId,
          photoGroupId,
          height: photo.height,
          width: photo.width,
          scale: 1,
          y: 50,
          x: 50,
        });
        ref.close();
      });
  }
}
